import type { TokenConfigType } from '@/constants/types/currency';
import type { ChainType } from '@/constants/chain-specific';
import { atomWithStorage } from 'jotai/utils';

// Store up to 5 recent tokens per chain
const MAX_RECENT_TOKENS = 8;

// Type for the storage structure
export interface RecentTokensStorage {
  [chainId: number]: TokenConfigType[];
}

export const recentTokensAtom = atomWithStorage<RecentTokensStorage>('recent-tokens', {});

// Helper function to update recent tokens
export const addToRecentTokens = (
  token: TokenConfigType,
  chainId: ChainType,
  currentStorage: RecentTokensStorage
): RecentTokensStorage => {
  // Get current tokens for this chain
  const currentChainTokens = currentStorage[chainId] || [];

  // Remove token if it already exists
  const filtered = currentChainTokens.filter(t => t.address !== token.address);

  // Add token to beginning of array
  const updated = [token, ...filtered].slice(0, MAX_RECENT_TOKENS);

  // Return updated storage with new tokens for this chain
  return {
    ...currentStorage,
    [chainId]: updated
  };
};

// Helper function to get recent tokens for a specific chain
export const getRecentTokensForChain = (
  chainId: ChainType,
  storage: RecentTokensStorage
): TokenConfigType[] => {
  return storage[chainId] || [];
};